export default "__VITE_ASSET__922f4f88__"